import { Injectable } from '@angular/core';

import { mergeMap } from 'rxjs/operators';

import { Actions, ofType, createEffect } from '@ngrx/effects';

import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { OsUpdateStatesResolverActions, AppleDeviceApiActions } from './os-update-states.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class OsUpdateStatesEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDeviceService: AppleDevicesService
  ) {}

  osUpdateStatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(OsUpdateStatesResolverActions.osUpdateStateRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDeviceService.getOsUpdateStatuses(udid, '2.0'),
          (states) =>
            AppleDeviceApiActions.osUpdateStateLoaded({
              osUpdateStatusses: states.map((state) => ({
                ...state,
                udid,
              })),
            }),
          (error) => AppleDeviceApiActions.osUpdateStateLoadedError({ error })
        )
      )
    );
  });
}
